
const it = {
    message: {
        title1:'CONTROLLO REMOTO DELLA TUA CASA, INTELLIGENTE, TECNOLOGICO, SICURO E TRANQUILLO',
        content1:"AigoSmart ti aiuta a gestire e controllare da remoto gli elettrodomestici intelligenti, i dispositivi possono collegarsi tra loro. L’attivazione con un clic permette di preimpostare vari elettrodomestici, creando una casa intelligente, sicura e senza preoccupazioni.",
        title2: "AigoSmart è un nuovo marchio secondario di Aigostar",
        content2: "I prodotti sono attualmente venduti in Spagna, Portogallo, Francia, Italia, Paesi Bassi, Germania, Finlandia, Danimarca, Polonia, Russia, Grecia, Austria, Svizzera, Repubblica Ceca, Ungheria, Slovacchia e altri paesi e regioni europei.",
        content3: "I vari piccoli elettrodomestici da cucina, lavanderia e stireria di AIGOSTAR continuano a occupare",
        content4: "Prime dieci vendite.",
        title3: "Brand Honor",
        content5: "Quick. Open. Innovate. Persevere",
        loading:'Caricamento',
        submit:'Invia',
        contactUs: "Contattaci",
        privacy:"Accordo sulla privacy",
        policy:"Service Policy",
        download:"Download",

    },
}

export default it;